import { makeActionCreator } from 'crazyEditor/redux/helpers';

export const UNDO_ACTION_ELEMENT = 'crazyEditor/element/UNDO_ACTION_ELEMENT';
export const REDO_ACTION_ELEMENT = 'crazyEditor/element/REDO_ACTION_ELEMENT';
export const REPLACE_STORE = 'crazyEditor/element/REPLACE_STORE';

export const undoActionElement = makeActionCreator(UNDO_ACTION_ELEMENT);
export const redoActionElement = makeActionCreator(REDO_ACTION_ELEMENT);
